angular.module('app').controller('ProductCtrl', function($scope, $controller, $http, $location, appUtils, $timeout, $mdDialog, $mdToast) {
    "ngInject";
    var main = this;

    main.name = 'product';
    main.defaults = {
        'unit_relationships': [],
        'fixed_product_relationships': [],
        'config': {
            'ORBOptions': []
        },
        'options': [],
        'units': 0,
        'type': 'alacarte'
    };
    main.productToAdd = null;
    main.optionToAdd = null;
    main.copyCollections = [
        {'name': 'fixed_product_relationships', 'key': 'id'},
        {'name': 'fixed_product_relationships', 'key': 'package_id'},
        {'name': 'unit_relationships', 'key': 'id'},
        {'name': 'unit_relationships', 'key': 'package_id'},
    ];
    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.addFixedProduct = function() {
        if(main.productToAddF) {
            main.item.fixed_product_relationships.push({
                'package_id': main.item.id,
                'product': main.productToAddF
            });
        }

        $scope.searchTextF = '';
        main.productToAddF = null;
    };

    main.addProductToAllowed = function() {
        if(main.productToAdd) {
            main.item.unit_relationships.push({
                'package_id': main.item.id,
                'product': main.productToAdd
            });
        }

        $scope.searchText = '';
        main.productToAdd = null;
    };

    main.addOption = function() {
        if(main.optionToAdd) {
            main.item.options.push (main.optionToAdd);
        }

        $scope.searchText = '';
        main.optionToAdd = null;
    };

    main.editOption = function(option) {
        if(option == null) {
            option = {
                'options': {
                    'choices': [],
                    'ORBOptions': []
                }
            };
            main.item.options.push(option);
        } else if (!option.options.ORBOptions) {
            option.options.ORBOptions = [];
        }

        $mdDialog.show({
            'controller': 'OptionCtrl',
            'controllerAs': 'main',
            'templateUrl': '/static/admin/templates/option.html',
            'multiple': true,
            'locals': {'option': option}
        });
    };

    main.removeFixedProduct = function(toRemove) {
        main.item.fixed_product_relationships = main.item.fixed_product_relationships.filter( function(item) {
            return toRemove !== item;
        });
    };

    main.removeUnitRelationship = function(toRemove) {
        main.item.unit_relationships = main.item.unit_relationships.filter( function(item) {
            return toRemove.product.id != item.product.id;
        });
    };

    main.save = function() {
        // Validate: Only one ProductOption can have ORB overrides
        if (main.item.options && main.item.options.length > 0) {
            var overrideCount = main.item.options.filter(function(opt) {
                return opt.options && (
                    opt.options.orb_override_id ||
                    opt.options.orb_override_price ||
                    opt.options.orb_override_label
                );
            }).length;

            if (overrideCount > 1) {
                var alert = $mdToast.simple()
                    .textContent('Error: Only one option can override lab configuration per product. Please remove overrides from other options.')
                    .position('top right')
                    .hideDelay(5000);
                $mdToast.show(alert);
                return;
            }
        }

        main.item.unit_relationships = main.item.unit_relationships.map(function(rel) {
            rel.product_id = rel.product.id;
            delete rel.product;
            return rel;
        });

        main._save()
    };

    main.searchOptions = function(text) {
        var query = appUtils.emptyQuery();

        if(main.item.options.length > 0) {
            query.q.filters.push({
                'name': 'id',
                'op': 'not_in',
                'val': main.item.options.map(function(item) {
                    return item.id;
                })
            });
        }

        return appUtils.search('product_option', text, query);
    };

    main.searchProducts = function(text) {
        var query = appUtils.emptyQuery();
        query.q.filters.push({
            'name': 'type',
            'op': 'neq',
            'val': 'package'
        });

        if(main.item.unit_relationships.length > 0) {
            query.q.filters.push({
                'name': 'id',
                'op': 'not_in',
                'val': main.item.unit_relationships.map(function(item) {
                    return item.product.id;
                })
            });
        }

        return appUtils.search('product', text, query);
    };
});
